import {useQuery} from "@tanstack/react-query";

import {getSessionQueryOptions} from "./get-session.query-options";

export function useGetSession() {
  return useQuery(getSessionQueryOptions());
}
